<template>
  <div>
    <img v-if="isAndroid" id="btn-app-android" @click="onClickButtonAndroid" src="@/assets/btn_app_android.png" />
    <img v-if="isIphone"  id="btn-app-iphone"  @click="onClickButtonIphone"  src="@/assets/btn_app_iphone.png" />
  </div>
</template>


<script>

export default {
  computed: {
    isAndroid() {
      return navigator.userAgent.match(/Android/i);
    },
    isIphone() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
  },
  methods: {
    onClickButtonAndroid() { 
      window.location.href = "https://play.google.com/store/apps/details?id=org.suisuitabi.yamanashi2022"
    },
    onClickButtonIphone() { 
      window.location.href = "https://apps.apple.com/jp/app/id1638668120"
    }
  },
  mounted() {
    
  },

}

</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
#btn-app-android
{
  width: 10rem;
}
#btn-app-iphone
{
  width: 9rem;
  padding: 0.5rem;
}
</style>





// WEBPACK FOOTER //
// src/components/Organisms/AppBanner.vue